import { FunctionComponent } from 'react'
import { Typography } from '@mui/material'
import { ReadinessSeverity } from '../../../shared/services/readiness/readiness.model'
import { READINESS_SEVERITY_LABELS, READINESS_SEVERITY_ORDER, READINESS_SEVERITY_TEXT_COLORS } from './readiness-labels'

// Per-severity finding counts as one caption line ("2 Critical · 3 Advisory"), in the severity
// palette, most severe first and zeros left out. Sits under the state chip on the partner Clients
// page so the partner sees why a client is where it is without opening the account.
export const ReadinessSeverityCounts: FunctionComponent<{
  counts: Record<ReadinessSeverity, number>,
}> = ({ counts }) => {
  const parts = READINESS_SEVERITY_ORDER.filter(severity => (counts[severity] || 0) > 0)
  if (parts.length === 0) {
    return <Typography variant='caption' sx={{ color: 'text.secondary', display: 'block' }}>No open findings</Typography>
  }
  return (
    <Typography variant='caption' sx={{ color: 'text.secondary', display: 'block', whiteSpace: 'nowrap' }}>
      {parts.map((severity, index) => (
        <span key={severity}>
          {index > 0 && ' · '}
          <Typography component='span' variant='caption' sx={{ color: READINESS_SEVERITY_TEXT_COLORS[severity] }}>
            {counts[severity]} {READINESS_SEVERITY_LABELS[severity]}
          </Typography>
        </span>
      ))}
    </Typography>
  )
}
